import React from 'react';
import PropTypes from 'prop-types';
import {Table, Sticky} from 'semantic-ui-react';
import isFunction from 'lodash/isFunction';

import SortIcon from './SortIcon';
import {isTruthy} from 'utils/DBUtils';
import {EmptyFunc} from '../../utils/DBUtils';
import {Tooltip} from 'react-tippy';
import {isNoU} from "../../utils/DBUtils";

const circledLetterClasses = {
  DAILYBREAK: 'circled-letter-web',
  DEMO: 'circled-letter-demo',
  EMBED: 'circled-letter-embed'
};

class ItemTable extends React.Component {
  render() {
    return (
      <Table
        celled={this.props.celled}
        compact={this.props.compact}
        collapsing={this.props.collapsing}
        className="break-table">
        <Table.Header>
          <Table.Row>
            {this.props.colDetails.map((details, index) => (
              <Table.HeaderCell key={details.id || index} width={details.width || null}>
                {isTruthy(details.canSort) ? <span className="table-header" onClick={() => this.props.onSortClick(details)}>{details.header}</span> : ""}
                {isTruthy(details.canSort) ? (<SortIcon onClick={() => this.props.onSortClick(details)} currentDirection={this.props.getSortDirectionForField(details.fieldName)}/>) : details.header}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.props.items.map((item, index) => (
            <Table.Row key={item.id || index} onClick={() => this.props.onRowClicked(item)}>
              {this.props.colDetails.map((detail, colIndex) => (

                <Table.Cell key={detail.id || colIndex}>
                  <div className={
                      this.props.showSubRows(item)
                         ? "break-table-rows table-addSub-" + this.props.getSubRows(item).length.toString() + " " + (isFunction(detail.className) ? detail.className(item) : (detail.className || ""))
                          : this.props.stretchedRows
                              ? "break-table-rows table-addSub-" + (this.props.getStretchContent(item).length + 1).toString() + " " + (isFunction(detail.className) ? detail.className(item) : (detail.className || ""))
                              : "break-table-rows table-noSub "+ (isFunction(detail.className) ? detail.className(item) : (detail.className || ""))}>
                    <div>
                      {colIndex === 0 && <div className='no-circled-letter'/>}

                      {(isFunction(detail.toolTip) ? detail.toolTip(item) : detail.toolTip) && colIndex === 0 && (item.breaks ? !isNoU(item.breaks.MASTER.title) : true)
                        ? <Tooltip trigger="mouseenter" followCursor="true" html={detail.toolTipData(item)} className="testing-Popper">
                            {detail.detailFunc(item)}
                          </Tooltip>
                        : detail.detailFunc(item)}
                    </div>

                    {this.props.animatedSubRows
                      ? (
                        <div>
                          {

                            this.props.showSubRows(item) && this.props.getSubRows(item).map((subRowItem, index) => this.props.showSubRow(subRowItem) && (
                            <div className="break-table-subrows fadeInDown animResponse" style={{zIndex: this.props.getSubRows(item).length-index}} key={subRowItem.id || index}>
                              {colIndex === 0 && (subRowItem.platform in circledLetterClasses
                                ? <div className={`circled-letter ${circledLetterClasses[subRowItem.platform] || ''}`}></div>
                                : <div className='no-circled-letter'/>)}
                              <div>{detail.subRowDetailFunc
                                  ? detail.subRowDetailFunc(subRowItem, item)
                                  : detail.detailFunc(subRowItem)}</div>
                            </div>
                          ))}
                        </div>
                      ) : this.props.showSubRows(item) ? this.props.getSubRows(item).map((subRowItem, index) => this.props.showSubRow(subRowItem) && (
                        <div className="break-table-subrows" key={subRowItem.id || index}>
                          {(subRowItem.platform in circledLetterClasses && colIndex === 0)
                            ? (
                              <div className={`circled-letter ${circledLetterClasses[subRowItem.platform] || ''}`}></div>
                            )
                            : (<div className='no-circled-letter'/>)}
                          <div>{detail.subRowDetailFunc
                              ? detail.subRowDetailFunc(subRowItem, item)
                              : detail.detailFunc(subRowItem)}</div>
                        </div>
                      )) : this.props.stretchedRows && this.props.getStretchContent(item).map((stretchItem, index) => (
                          <div className="break-table-subrows" key={stretchItem + index}>
                            {detail.stretchDetailFunc ? detail.stretchDetailFunc(stretchItem) : null}
                          </div>
                      ))
                    }
                  </div>
                </Table.Cell>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    )
  }
}

export const propShape = {
  collapsing: PropTypes.bool,
  compact: PropTypes.any,
  items: PropTypes.array.isRequired,
  colDetails: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      detailFunc: PropTypes.func.isRequired, // TODO: Default?
      subRowDetailFunc: PropTypes.func,
      stretchDetailFunc: PropTypes.func,
      multiLine: PropTypes.array,
      fieldName: PropTypes.string,
      canSort: PropTypes.bool
    })
  ).isRequired,
  onRowClicked: PropTypes.func.isRequired,
  onSortClick: PropTypes.func,
  getSortDirectionForField: PropTypes.func,
  showSubRows: PropTypes.func,
  getSubRows: PropTypes.func,
  stretchedRows: PropTypes.bool,
  getStretchContent: PropTypes.func,
  animatedSubRows: PropTypes.bool,
  animationType: PropTypes.string,
  animationDuration: PropTypes.number
};

ItemTable.propTypes = propShape;

ItemTable.defaultProps = {
  showColumnSort: true,
  getSortDirectionForField: EmptyFunc,
  onSortClick: EmptyFunc,
  showSubRows: () => false,
  getSubRows: () => []
};

export default ItemTable;



// WEBPACK FOOTER //
// ./public/components/common/ItemTable.jsx